/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  VueFormatterFeatureServiceInterface,
  LocaleService,
} from '../../types/feature-service-types';
import type { Logger } from '@feature-hub/core';
import { createContext } from 'react';

type ContentContextState = {
  content: any;
  vueFormatterService: VueFormatterFeatureServiceInterface;
  localeService: LocaleService;
  logger?: Logger;
};

export const ContentContext = createContext<Partial<ContentContextState>>({});
